import { cachedHttp } from "./httpService";

const apiEndPoint = "/slackchannels/";

function getSlackChannels() {
  return cachedHttp.get(apiEndPoint);
}

export default getSlackChannels;
